import React, { useEffect, useState, useRef } from "react";
import { Container, Form, Row, Col, Button, Modal } from "react-bootstrap";
import { getStyles } from "./AddProduct.style";
import AddProductImage from "../../assets/images/addProductTitle.png";
import TitleBar from "../../Components/TitleBar/TitleBar";
import Section from "../../Components/Section/Section";
import { toast } from "react-toastify";
import { TiPlus } from "react-icons/ti";
import { ImCross } from "react-icons/im";
import {
  Add_Bulk_Upload,
  Add_Product,
  All_Subcategories,
  subcategories,
  Unit_Of_Measure,
} from "../../Api";
import { Link, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaSearch } from "react-icons/fa"; // Import FaArrowLeft icon

import AddProductFromSystem from "../../Components/AddProductFromSystem/AddProductFromSystem";
import { STORAGE_CONSTANTS } from "../../shared/Constants/Constants";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { set } from "lodash";
import {
  Get_Brand_Categories,
  Get_Brands,
  Request_New_Brand,
} from "../../Api/apis/brandApi";
import BtnLoader from "./components/BtnLoader";
import { brandSchema, schema } from "./validation";

import { Category } from "./types";
import ProductBulkUpload from "./components/ProductBulkUpload";

const AddProduct: React.FC = () => {
  const { t, i18n } = useTranslation();

  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  const styles = getStyles(isMobile);
  const breadcrumbs = [
    <Link to="/" key="home">
      {t("footer.home")}
    </Link>,
    "Store",
  ];
  const title: string = t("product.addProduct");

  const imageUrl: string = AddProductImage;

  const [productType, setProductType] = useState<"single" | "bulk" | "system">(
    "single",
  );
  const [productName, setProductName] = useState("");
  const [category, setCategory] = useState("");
  const [description, setDescription] = useState("");
  const [unitsOfMeasure, setUnitsOfMeasure] = useState<any>("");
  const [variants, setVariants] = useState("");
  const [minQuantity, setMinQuantity] = useState("");
  const [inventory, setInventory] = useState("");
  const [price, setPrice] = useState("");
  const [productImage, setProductImage] = useState<any>("");
  const [fileType, setFileType] = useState<any>("");
  const [additionalImage1, setAdditionalImage1] = useState<any>("");
  const [additionalImage2, setAdditionalImage2] = useState<any>("");

  // brand images
  const [brandLogo, setBrandLogo] = useState<any>("");
  const [authorizationLetter, setAuthorizationLetter] = useState<any>("");
  const [brands, setBrands] = useState<Category[]>([]);
  const [showBrandAddOption, setShowBrandAddOption] = useState<boolean>(false);
  const [showBrandForm, setShowBrandForm] = useState<boolean>(false);
  const [filteredBrands, setFilteredBrands] = useState<Category[]>([]);
  const [brandSearch, setBrandSearch] = useState("");
  const [selectedBrand, setSelectedBrand] = useState<boolean>(false);
  const [categories, setCategories] = useState<Category[]>([]);
  const [categorySearch, setCategorySearch] = useState("");
  const [selectedCategory, setSelectedCategory] = useState<boolean>(false);
  const [filteredCategories, setFilteredCategories] = useState<Category[]>([]);
  const [showModal, setShowModal] = useState(false);
  const brandDropdownRef = useRef<HTMLDivElement>(null);
  const productImageRef = useRef<HTMLDivElement>(null);

  const [userToken, setUserToken] = useState<string | null>("");
  const [sub, setSub] = useState<Category[]>([]);
  const navigate = useNavigate();

  const [productQuantity, setProductQuantity] = useState("");
  const [systemProductID, setSystemProductID] = useState("");
  const [productNameInNepali, setProductNameInNepali] = useState("");
  const [descriptionInNepali, setDescriptionInNepali] = useState("");
  const [priceInNepali, setPriceInNepali] = useState("");
  const [template, setTemplate] = useState<any>({});
  const [storeId, setStoreId] = useState<any>("");
  const [status, setStatus] = useState<any>("");
  const [file, setFile] = useState<any>(null);
  const [zip, setZip] = useState<any>(null);
  const [productError, setProductError] = useState<any>("");
  const [fileName, setFileName] = useState<any>("");
  const [zipFileName, setZipFileName] = useState<string>("");
  const [isLoading, setLoading] = useState<boolean>(false);
  const [bulkErrorDetails, setBulkErrorDetails] = useState<any>(null); // New state to store error message and file path

  const [storeError, setStoreError] = useState<{
    weight?: string;
    available?: string;
    product_image?: string;
    maximum_qty?: string;
    // store_type?:string;
  }>({});
  // const [storeError, setStoreError] = useState<{
  //   product_image?: string;
  // }>({});

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // brands feature.
  useEffect(() => {
    if (brandSearch === "") {
      setShowBrandAddOption(false);
      setSelectedBrand(false);
      setValue("brand", "");
    } else {
      // Check if there are any exact matching brands (case insensitive)
      const matchingBrands = brands.filter((b) => 
        b.name.toLowerCase() === brandSearch.toLowerCase()
      );
      
      // If exact match found, auto-select it
      if (matchingBrands.length > 0) {
        const exactMatch = matchingBrands[0];
        setValue("brand", exactMatch.id);
        setSelectedBrand(true);
        setShowBrandAddOption(false);
      } else {
        // No exact match found, show add option
        setShowBrandAddOption(true);
        setSelectedBrand(false);
        setValue("brand", brandSearch);
      }
    }
  }, [brandSearch, brands]);

  const fetchBrandCategories = async () => {
    try {
      const response = await Get_Brand_Categories();

      if (response && response.status === 200) {
        setCategories(response.data);
      } else {
        console.log("Error fetching Brand Categories");
      }
    } catch (error) {
      console.log("Error fetching Brand Categories", error);
    }
  };

  const fetchBrands = async () => {
    try {
      const response = await Get_Brands();

      if (response && response.status === 200) {
        setBrands(response.data);
      } else {
        console.log("Error fetching Brands");
      }
    } catch (error) {
      console.log("Error fetching Brands", error);
    }
  };

  useEffect(() => {
    fetchBrandCategories();
    fetchBrands();
  }, []);

  // Handle outside click for brand dropdown
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (brandDropdownRef.current && !brandDropdownRef.current.contains(event.target as Node)) {
        // Only show add brand option if:
        // 1. There's a search term
        // 2. No brand is selected
        // 3. No exact matching brands are found
        if (brandSearch && !selectedBrand) {
          const matchingBrands = brands.filter((b) => 
            b.name.toLowerCase() === brandSearch.toLowerCase()
          );
          if (matchingBrands.length === 0) {
            setShowBrandAddOption(true);
          } else {
            setShowBrandAddOption(false);
          }
        }
        setFilteredBrands([]);
      }
    };

    if (brandSearch) {
      document.addEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [brandSearch, filteredBrands, selectedBrand, brands]);

  const fetchCategories = async () => {
    try {
      const response = await subcategories();
      if (response && response.status === 200) {
        setSub(response.data.sub_cat_list);
      } else {
        console.log("Error fetching Subcategories");
      }
    } catch (error) {
      console.log("Error fetching Subcategories", error);
    }
  };

  const fetchUnit = async () => {
    try {
      const response = await Unit_Of_Measure();
      if (response && response.status === 200) {
        // setSub(response.data);
        setUnitsOfMeasure(response.data.product_list);
      } else {
        console.log("Error fetching Subcategories");
      }
    } catch (error) {
      console.log("Error fetching Subcategories", error);
    }
  };

  // const fetchBulk = async () => {
  //   try {
  //     const response = await Get_Bulk_Upload(userToken);
  //     if (response && response.status === 200) {
  //       setStoreId(response.data.stores_list[0].id)
  //     } else {
  //       console.log("Error fetching BulkFile");
  //     }
  //   } catch (error) {
  //     console.log("Error fetching BulkFile", error);
  //   }
  // };

  // useEffect(() => {
  //   fetchCategories();
  // }, []);

  console.log(brands, "brands=========>");

  const {
    register: brandRegister,
    formState: { errors: brandErrors },
    control: brandControl,
    handleSubmit: brandHandleSubmit,
    setValue: setBrandValue,
  } = useForm({
    resolver: yupResolver(brandSchema),
  });

  const handleAddBrandSubmit = async (brandData: any) => {
    if (!brandLogo) {
      toast.error("Please select a brand logo");
      return;
    }

    const selected_category = brandData.brandCategory;
    const categoryExists = categories.some((category) => {
      return category.id == selected_category;
    });

    if (!categoryExists) {
      toast.error("Please select a valid category from the list!");
      return;
    }
    const formData = new FormData();
    formData.append("brand_name", brandData.brand);
    formData.append("brandOwner", brandData.brandOwner);
    formData.append("brandCategory", brandData.brandCategory);
    formData.append("brandLogo", brandLogo);
    formData.append("authorizationLetter", authorizationLetter);
    const response = await Request_New_Brand(formData);
    if (response && response.status === 201) {
      toast.success("Brand request submitted successfully");
      setShowModal(false);
      clearStates();
      // navigate('/products')
    }
  };

  const clearStates = () => {
    handleAddBrand();
    setBrandSearch("");
  };

  const {
    register,
    formState: { errors },
    control,
    handleSubmit,
    setValue,
  } = useForm({
    // defaultValues: {
    //   inventory: "0", // Default value for inventory
    // },
    resolver: yupResolver(schema),
    // defaultValues: {
    //   productName: 'Default Product Name', // Set your default value here
    // }
  });

  const handleProductTypeChange = (type: "single" | "bulk" | "system") => {
    setProductType(type);
    // Reset related fields when switching product types
    setProductName("");
    setCategory("");
    setDescription("");
    setUnitsOfMeasure("");
    setVariants("");
    setMinQuantity("");
    setInventory("");
    setPrice("");
    setProductQuantity("");
    setSystemProductID("");
    setProductNameInNepali("");
    setDescriptionInNepali("");
    setPriceInNepali("");
  };

  useEffect(() => {
    setUserToken(localStorage.getItem(STORAGE_CONSTANTS.USER_TOKEN));
    setStoreId(localStorage.getItem(STORAGE_CONSTANTS.STORE_ID));
    setStatus(localStorage.getItem(STORAGE_CONSTANTS.STORE_STATUS));
    fetchCategories();
    fetchUnit();
    window.scrollTo(0, 0);
  }, []);

  const handleSubmits = async (data: any) => {
    if (data) {
      const selectedBrand = brands.some((b) => b.id == data.brand);
      // const selectedBrand = brands.some((b) => b.name == data.brand);
      if (!selectedBrand) {
        toast.error("Please select a valid brand from the list");
        return;
      }

      try {
        setLoading(true);
        const payload = {
          ...data,
          usd_price: 0,
          product_vendor_store:
            storeId || localStorage.getItem(STORAGE_CONSTANTS.STORE_ID),
        };
        const response: any = await Add_Product(
          payload,
          productImage,
          additionalImage1,
          additionalImage2,
        );

        if (response.status == 413) {
          toast.error("The file size should be less than 5 MB.");
        }
        if (response && response.status === 200) {
          toast.success(response["data"]["message"]);
          navigate("/products");
        } else {
          console.log(response.data, "error=======>");
          // toast.error(response?.data?.error_message);
        }
      } catch (error: any) {
        if (error.response?.status === 413) {
          toast.error("The file size should be less than 5 MB.");
          return;
        }
        // BE responds with { status, message, error: { field: [msg] } }
        const resData = error.response?.data || {};
        const rawErrors =
          resData.error && typeof resData.error === "object"
            ? resData.error
            : {};
        const fieldErrors: Record<string, string> = {};
        Object.entries(rawErrors).forEach(([field, value]) => {
          fieldErrors[field] = String(Array.isArray(value) ? value[0] : value);
        });
        const firstErrorMessage = Object.values(fieldErrors)[0];
        toast.error(
          firstErrorMessage || resData.message || "Something went wrong!",
        );
        setStoreError(fieldErrors);
        if (fieldErrors.product_image) {
          productImageRef.current?.scrollIntoView({
            behavior: "smooth",
            block: "center",
          });
        }
        // setStoreError(error?.response?.data?.error_message);
        // setProductError(error?.response?.data?.error_message);
      } finally {
        setLoading(() => false);
      }
    }
  };

  const handleFileChange = (e: any, onChange: (file: File) => void) => {
    const file = e.target.files[0];
    setProductImage(file);
    onChange(file);
    // a new file invalidates any earlier BE error (e.g. "too large")
    setStoreError((prev) => ({ ...prev, product_image: undefined }));
    e.preventDefault();
  };

  const handleAdditionalFile1 = (e: any) => {
    setAdditionalImage1(e.target.files[0]);
  };

  const handleAdditionalFile2 = (e: any) => {
    setAdditionalImage2(e.target.files[0]);
  };


  // brand images:
  const handleBrandLogoChange = (e: any) => {
    setBrandLogo(e.target.files[0]);
  };

  const handleAuthorizationLetterChange = (e: any) => {
    setAuthorizationLetter(e.target.files[0]);
  };

  const handleAddBrand = () => {
    setShowBrandForm(!showBrandForm);
    setBrandLogo("");
    setAuthorizationLetter("");
    setBrandValue("brandOwner", "");
    setBrandValue("brandCategory", "");
    setCategorySearch("");
    setSelectedCategory(false);
    setFilteredCategories([]);
    setShowModal(!showModal);
  };

  const showBrandDropDown = () => {
    // Toggle dropdown visibility or implement specific dropdown logic
    // console.log("Show brand dropdown clicked");
  };

  const handleBrandSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setBrandSearch(value);
    setBrandValue("brand", value);
    setValue("brand", value);
    setFilteredBrands(
      brands.filter((b) => b.name.toLowerCase().includes(value.toLowerCase())),
    );
  };
  const handleBrandCategorySearch = (
    e: React.ChangeEvent<HTMLInputElement>,
  ) => {
    const value = e.target.value;
    setCategorySearch(value);
    setBrandValue("brandCategory", value);
    setSelectedCategory(false);

    if (value === "") {
      setFilteredCategories(categories);
    } else {
      const filtered = categories.filter((category) =>
        category.name.toLowerCase().includes(value.toLowerCase()),
      );
      setFilteredCategories(filtered);
    }
  };

  const handleBulkFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // if (e.target.files && e.target.files.length > 0) {
    //   const selectedFile = e.target.files[0];
    //   setFile(selectedFile);
    // }
    const file = e.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setFile(file);
      getFileExtension(file.name);
    }
    e.preventDefault();
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      setFileName(selectedFile.name);
    }
  };

  const handleBulkZipChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      // setSelectedAdditionalImage1(imageUrl);
      setZip(file);
    }
    e.preventDefault();
    if (e.target.files && e.target.files.length > 0) {
      const selectedFile = e.target.files[0];
      setZipFileName(selectedFile.name);
    }
  };
  // setValue

  const getFileExtension = (filename: any) => {
    const parts = filename.split(".");
    const fileType = parts.pop();
    if (fileType === "xls" || fileType === "xlsx") {
      setFileType("excel");
    } else if (fileType === "csv") {
      setFileType("csv");
    }
  };

  // const handleFormSubmit = (e: any) => {
  //   e.preventDefault();
  //   // alert("hiii")
  //   if (file) {
  //     const BulkProduct = async () => {
  //       try {
  //         setLoading(true);
  //         const response = await Add_Bulk_Upload(
  //           userToken,
  //           storeId,
  //           file,
  //           zip,
  //           fileType
  //         );
  //         if (response && response.status === 202) {
  //           showToastMessage(response.data);
  //           console.log(response.data);
  //           navigate("/products");
  //           setFile("");
  //           setZip("");
  //           setFileType("");
  //           setFileName("");
  //           setZipFileName("");
  //         } else {
  //           console.log(response.data);
  //         }
  //       } catch (error: any) {
  //         console.error("Error occurred:", error.response.data);
  //         setFile("");
  //         setZip("");
  //         setFileType("");
  //         setFileName("");
  //         setZipFileName("");
  //         setStoreError(error.response.data);
  //       } finally {
  //         setLoading(() => false)
  //       }
  //     };
  //     BulkProduct();
  //   } else {
  //     toast.error("Please select a file to upload");
  //   }
  //   console.log("Uploading file:", file);
  // };

  const handleFormSubmit = (e: any) => {
    e.preventDefault();
    if (file) {
      const BulkProduct = async () => {
        try {
          setLoading(true);
          const response = await Add_Bulk_Upload(
            userToken,
            storeId,
            file,
            zip,
            fileType,
          );

          // Check for status code 202 (successful upload)
          if (response.status === 202) {
            showToastMessage(response.data);

            // If the bulk upload completed with errors
            if (response.data.errors && response.data.error_file_path) {
              setBulkErrorDetails({
                message: response.data.message,
                errorFilePath: response.data.error_file_path,
                totalFaildProduct: response.data.total_faild_product,
                totalUploadProduct: response.data.total_upload_product,
                createdRecord: response.data.created,
                error: response.data.error,
              });
            }

            navigate("/products");
            resetForm();
          }
          // Handle case for 400 status (Bad Request)
          else if (response.status === 400) {
            setBulkErrorDetails({
              message:
                response.data.message || "Bulk upload completed with errors.",
              error: response.data.error,
              errorFilePath: response.data.error_file_path || null,
              totalFaildProduct: response.data.total_faild_product || null,
              totalUploadProduct: response.data.total_upload_product || null,
              createdRecord: response.data.created || null,
            });
          }
          // Handle any other unexpected status codes
          else {
            setBulkErrorDetails({
              message: "Bulk upload failed with an unexpected error.",
              errorFilePath: null,
              totalFaildProduct: null,
              totalUploadProduct: null,
              createdRecord: null,
              error: null,
            });
          }
        } catch (error: any) {
          console.error("Error occurred:", error.response?.data || error);
          if (error.response?.data) {
            // Specific error message and details
            setBulkErrorDetails({
              message:
                error.response?.data.message ||
                "Error occurred during bulk upload.",
              errorFilePath: error.response?.data.error_file_path || null,
              totalFaildProduct:
                error.response?.data.total_faild_product || null,
              totalUploadProduct:
                error.response?.data.total_upload_product || null,
              createdRecord: error.response?.data.created || null,
              error: error.response.data.error || null,
            });
          } else {
            setBulkErrorDetails({
              message: "An unexpected error occurred during the upload.",
              errorFilePath: null,
              totalFaildProduct: null,
              totalUploadProduct: null,
              createdRecord: null,
              error: null,
            });
          }
          resetForm();
        } finally {
          setLoading(false);
        }
      };
      BulkProduct();
    } else {
      toast.error("Please select a file to upload");
    }
  };

  // Reset form function
  const resetForm = () => {
    setFile("");
    setZip("");
    setFileType("");
    setFileName("");
    setZipFileName("");
  };

  // Handle file download
  const handleFileDownload = () => {
    if (bulkErrorDetails?.errorFilePath) {
      const link = document.createElement("a");
      link.href = bulkErrorDetails.errorFilePath; // Set the file URL
      link.target = "_blank"; // Open in a new tab if needed (optional)
      link.download = "error_log.csv"; // Set the desired download file name
      link.click(); // Programmatically trigger the click event
    } else {
      console.error("Error file path is not available");
    }
  };

  const showToastMessage = (response: any) => {
    const { created, repeated } = response;

    const repeatedProductText = repeated > 1 ? "Products" : "Product";
    const createdProductText = created > 1 ? "Products" : "Product";

    if (created > 0 && repeated === 0) {
      toast.success("Bulk upload successful");
    } else if (created > 0 && repeated > 0) {
      toast.success(
        `${created} new ${createdProductText} added, ${repeated} ${repeatedProductText} repeated`,
      );
    } else if (created === 0 && repeated > 0) {
      toast.error(`${repeated} ${repeatedProductText} repeated`);
    }
  };

  // const downloadSampleCSV = (e:any) => {
  //   // Replace the sample data with your actual CSV template
  //   e.preventDefault()
  //   // const url = template.csv;
  //   // const link = document.createElement("a");
  //   // link.href = url;
  //   // link.setAttribute("download", "sample.csv");
  //   // document.body.appendChild(link);
  //   // link.click();
  //   // document.body.removeChild(link);
  //   fetchBulk()
  // };

  // console.log(file,"file=------------")
  // console.log(storeId, "erewwwwwwwww");

  const handleShowModal = () => setShowModal(true);
  const handleCloseModal = () => {
    setShowModal(false);
    setShowBrandForm(false);
  };

  return (
    <div className="addProductWrap">
      <TitleBar breadcrumbs={breadcrumbs} title={title} imageUrl={imageUrl} />
      <Section className="addProduct" style={{ marginTop: -60 }}>
        <div style={styles.whiteWrap}>
          <Container>
            <Form>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  position: "relative",
                }}
              >
                <div
                  style={{ position: "absolute", left: 0, top: 5 }}
                  className="hide-xs"
                >
                  <Link to="/products">
                    <FaArrowLeft className="arrow-left" />{" "}
                  </Link>
                </div>
                <div
                  style={{ position: "relative", left: 0, top: 0 }}
                  className="hide-lg"
                >
                  <Link to="/products">
                    <FaArrowLeft className="arrow-left" />{" "}
                  </Link>
                </div>
                <Form.Group>
                  <Form.Check
                    inline
                    type="radio"
                    id="single"
                    label={t("product.single")}
                    checked={productType === "single"}
                    onChange={() => handleProductTypeChange("single")}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    id="bulk"
                    label={t("product.bulk")}
                    checked={productType === "bulk"}
                    onChange={() => handleProductTypeChange("bulk")}
                  />
                  <Form.Check
                    inline
                    type="radio"
                    id="system"
                    label={t("product.fromSystem")}
                    checked={productType === "system"}
                    onChange={() => handleProductTypeChange("system")}
                  />
                </Form.Group>
              </div>

              {productType === "single" && (
                <>
                  <Form.Group controlId="productName">
                    <Form.Label>{t("product.productName")}*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={t("product.enterProductName")}
                      {...register("productName")}
                    />
                    {errors?.productName && (
                      <span style={styles.error}>
                        {errors?.productName?.message}
                      </span>
                    )}
                    {productError && (
                      <span style={styles.error}>{productError}</span>
                    )}

                    {/* {storeError && (<span style={styles.error}>
                        {storeError}
                      </span>)} */}
                  </Form.Group>

                  <Row>
                    <Form.Group as={Col} controlId="Brand">
                      <Form.Label>{t("product.brand")}*</Form.Label>
                      <div ref={brandDropdownRef} style={{ position: "relative" }}>
                        <Form.Control
                          type="text"
                          placeholder={t("product.enterBrand")}
                          value={brandSearch}
                          onChange={handleBrandSearch}
                          // {...brandRegister("brand")}
                          style={{ paddingRight: "40px" }}
                          autoComplete="off"
                        />
                        {showBrandAddOption ? (
                          <>
                            <button
                              type="button"
                              style={{
                                ...styles.addBtnStyle,
                                background: showBrandForm
                                  ? "#ff4d4f"
                                  : "#1890ff",
                              }}
                              onClick={handleAddBrand}
                            >
                              {showBrandForm ? (
                                <div className="mb-1">
                                  <ImCross size={12} />
                                </div>
                              ) : (
                                <div className="">
                                  <TiPlus />
                                </div>
                              )}
                            </button>
                          </>
                        ) : (
                          <>
                            {/* <button
                              type="button"
                              style={{
                                position: "absolute",
                                right: "8px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                background: showBrandForm
                                  ? "#ff4d4f"
                                  : "#1890ff",
                                color: "#fff",
                                border: "none",
                                borderRadius: "4px",
                                padding: "2px 10px",
                                cursor: "pointer",
                                fontSize: "18px",
                                lineHeight: "1",
                              }}
                              onClick={showBrandDropDown}
                            >
                              suj
                            </button> */}
                          </>
                        )}

                        {brandSearch && filteredBrands.length > 0 && (
                          <div
                            style={{
                              ...styles.filterBrands,
                            }}
                          >
                            {filteredBrands.map((b, idx) => (
                              <div
                                key={idx}
                                style={{ padding: "8px", cursor: "pointer" }}
                                onClick={() => {
                                  setBrandSearch(b.name);
                                  setShowBrandAddOption(false);
                                  setFilteredBrands([]);
                                  setValue("brand", b.id);
                                  // setValue("brand", b.name);
                                  setBrandValue("brand", b.name);
                                  setSelectedBrand(true);
                                  setShowBrandForm(false);
                                }}
                              >
                                {b.name}
                              </div>
                            ))}
                          </div>
                        )}
                      </div>
                      {errors?.brand && (
                        <span style={styles.error}>
                          {errors?.brand?.message}
                        </span>
                      )}
                      {errors?.brand && (
                        <span style={styles.error}>
                          {errors?.brand?.message}
                        </span>
                      )}

                      {showBrandAddOption && (
                        <>
                          <span style={styles.error}>
                            Brand is not available !
                          </span>{" "}
                          <span
                            className="text-decoration-underline text-primary cursor_pointer"
                            onClick={handleAddBrand}
                          >
                            Click Add
                          </span>
                        </>
                      )}
                    </Form.Group>
                  </Row>

                  <Modal show={showModal} onHide={handleCloseModal} centered>
                    <Modal.Header closeButton>
                      <Modal.Title>{t("product.addNewBrand")}</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                      <Row>
                        <Form.Group as={Col} controlId="Brand">
                          <Form.Label>{t("product.brand")}*</Form.Label>
                          <div style={{ position: "relative" }}>
                            <Form.Control
                              type="text"
                              placeholder={t("product.enterBrand")}
                              value={brandSearch}
                              onChange={handleBrandSearch}
                              // {...brandRegister("brand")}
                              style={{ paddingRight: "40px" }}
                              autoComplete="off"
                            />
                            {showBrandAddOption && (
                              <>
                                <button
                                  type="button"
                                  style={{
                                    ...styles.addBtnStyle,
                                    background: showBrandForm
                                      ? "#ff4d4f"
                                      : "#1890ff",
                                  }}
                                  onClick={handleAddBrand}
                                >
                                  {showBrandForm ? (
                                    <div className="mb-1">
                                      <ImCross size={12} />
                                    </div>
                                  ) : (
                                    <div className="">
                                      <TiPlus />
                                    </div>
                                  )}
                                </button>
                              </>
                            )}

                            {brandSearch && filteredBrands.length > 0 && (
                              <div
                                style={{
                                  ...styles.filterBrands,
                                }}
                              >
                                {filteredBrands.map((b, idx) => (
                                  <div
                                    key={idx}
                                    style={{
                                      padding: "8px",
                                      cursor: "pointer",
                                    }}
                                    onClick={() => {
                                      setBrandSearch(b.name);
                                      setShowBrandAddOption(false);
                                      setFilteredBrands([]);
                                      // setValue("brand", b.id);
                                      setValue("brand", b.name);
                                      setBrandValue("brand", b.name);
                                      setSelectedBrand(true);
                                      setShowBrandForm(false);
                                    }}
                                  >
                                    {b.name}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                          {errors?.brand && (
                            <span style={styles.error}>
                              {errors?.brand?.message}
                            </span>
                          )}
                        </Form.Group>
                      </Row>
                      <Row>
                        {showBrandForm && (
                          <div className="d-flex flex-column gap-3 my-1">
                            <Form.Group controlId="productLogo">
                              <Form.Label>{t("product.brandLogo")}</Form.Label>
                              <Form.Control
                                type="file"
                                accept="image/*"
                                onChange={(e) => handleBrandLogoChange(e)}
                              />
                            </Form.Group>
                            <Form.Group as={Col} controlId="brandOwner">
                              <Form.Label>
                                {t("product.brandOwner")}*
                              </Form.Label>
                              <Form.Control
                                type="text"
                                placeholder={t("product.brandOwner")}
                                {...brandRegister("brandOwner")}

                                // value={minQuantity}
                                // onChange={(e) => setMinQuantity(e.target.value)}
                                // required
                              />
                              {brandErrors?.brandOwner && (
                                <span style={styles.error}>
                                  {brandErrors?.brandOwner?.message}
                                </span>
                              )}
                              {/* {storeError?.weight && (
                        <span style={styles.error}>
                          {storeError?.weight}
                        </span>
                      )} */}
                            </Form.Group>
                            <Form.Group controlId="brandCategory">
                              <Form.Label>
                                {t("product.brandCategory")}*
                              </Form.Label>
                              <div style={{ position: "relative" }}>
                                <Form.Control
                                  type="text"
                                  placeholder="Select brand category"
                                  value={categorySearch}
                                  onChange={handleBrandCategorySearch} // Use the brand category handler
                                  style={{ paddingRight: "10px" }}
                                  autoComplete="off"
                                />

                                {/* Brand Category Suggestions */}
                                {categorySearch &&
                                  filteredCategories.length > 0 &&
                                  !selectedCategory && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        background: "#fff",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        zIndex: 10,
                                        maxHeight: "150px",
                                        overflowY: "auto",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                      }}
                                    >
                                      {filteredCategories.map(
                                        (category, idx) => (
                                          <div
                                            key={idx}
                                            style={{
                                              padding: "10px 12px",
                                              cursor: "pointer",
                                              borderBottom:
                                                idx <
                                                filteredCategories.length - 1
                                                  ? "1px solid #f0f0f0"
                                                  : "none",
                                              fontSize: "14px",
                                            }}
                                            onClick={() => {
                                              setCategorySearch(category.name); // Use category.name
                                              setBrandValue(
                                                "brandCategory",
                                                category.id,
                                              ); // Set the name in form
                                              setFilteredCategories([]);
                                              setSelectedCategory(true);
                                            }}
                                            onMouseEnter={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "#f5f5f5";
                                            }}
                                            onMouseLeave={(e) => {
                                              e.currentTarget.style.backgroundColor =
                                                "transparent";
                                            }}
                                          >
                                            {category.name}{" "}
                                            {/* Display category.name instead of just category */}
                                          </div>
                                        ),
                                      )}
                                    </div>
                                  )}

                                {categorySearch &&
                                  filteredCategories.length === 0 &&
                                  !selectedCategory && (
                                    <div
                                      style={{
                                        position: "absolute",
                                        top: "100%",
                                        left: 0,
                                        right: 0,
                                        background: "#fff",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        zIndex: 10,
                                        padding: "10px 12px",
                                        color: "#999",
                                        fontSize: "14px",
                                        boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
                                      }}
                                    >
                                      No categories found
                                    </div>
                                  )}
                              </div>

                              {brandErrors?.brandCategory && (
                                <span style={styles.error}>
                                  {brandErrors?.brandCategory?.message}
                                </span>
                              )}
                            </Form.Group>

                            <Form.Group controlId="authorizationLetter">
                              <Form.Label>
                                {t("product.authorizationLetter")}
                              </Form.Label>
                              <Form.Control
                                type="file"
                                accept="image/*"
                                onChange={(e) =>
                                  handleAuthorizationLetterChange(e)
                                }
                              />
                              {storeError?.product_image && (
                                <span style={styles.error}>
                                  {storeError?.product_image}
                                </span>
                              )}
                            </Form.Group>

                            <div className="align-items-center justify-content-center d-flex">
                              <button
                                type="submit"
                                className="btnBlue submit"
                                disabled={isLoading}
                                onClick={brandHandleSubmit(
                                  handleAddBrandSubmit,
                                )}
                                value="Add brand"
                              >
                                {isLoading ? (
                                  <BtnLoader />
                                ) : (
                                  t("product.addBrand")
                                )}
                              </button>
                            </div>
                          </div>
                        )}
                      </Row>
                    </Modal.Body>
                  </Modal>
                  <Form.Group controlId="category">
                    <Form.Label>{t("product.category")}*</Form.Label>
                    <Controller
                      name="category"
                      control={control}
                      defaultValue=""
                      render={({ field }) => (
                        <Form.Control as="select" {...field}>
                          <option value="" disabled>
                            {t("product.selectSubcategory")}
                          </option>
                          {sub.map((item) => (
                            <option key={item.id} value={item.id}>
                              {item.name}
                            </option>
                          ))}
                        </Form.Control>
                      )}
                    />
                    {errors?.category && (
                      <span style={styles.error}>
                        {errors?.category?.message}
                      </span>
                    )}
                  </Form.Group>
                  <Form.Group controlId="description">
                    <Form.Label>{t("product.description")}*</Form.Label>
                    <Form.Control
                      as="textarea"
                      rows={3}
                      placeholder={t("product.enterProductDescription")}
                      {...register("description")}
                      // value={description}
                      // onChange={(e) => setDescription(e.target.value)}
                    />
                    {errors?.description && (
                      <span style={styles.error}>
                        {errors?.description?.message}
                      </span>
                    )}
                  </Form.Group>
                  <Row>
                    <Form.Group as={Col} controlId="unitOfMeasure">
                      <Form.Label>{t("product.unitOfMeasure")}*</Form.Label>
                      <Controller
                        name="unitOfMeasure"
                        control={control}
                        defaultValue=""
                        render={({ field }) => (
                          <Form.Control as="select" {...field}>
                            <option value="" disabled>
                              {"Select an option"}
                            </option>
                            {unitsOfMeasure &&
                              unitsOfMeasure.map((item: any) => (
                                <option
                                  key={item.id}
                                  value={item.unit_of_measure}
                                >
                                  {item.unit_of_measure}
                                </option>
                              ))}
                          </Form.Control>
                        )}
                      />
                      {errors?.unitOfMeasure && (
                        <span style={styles.error}>
                          {errors?.unitOfMeasure?.message}
                        </span>
                      )}
                    </Form.Group>
                    {/* <Form.Group as={Col} controlId="price">
                      <Form.Label>{t("product.priceUsd")}</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={t("product.enterProductPrice")}
                        {...register("price")}

                        // value={price}
                        // onChange={(e) => setPrice(e.target.value)}
                      />
                      {errors?.price && (
                        <span style={styles.error}>
                          {errors?.price?.message}
                        </span>
                      )}
                    </Form.Group> */}
                    <Form.Group as={Col} controlId="variants">
                      <Form.Label>{t("product.variations")}*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={t("product.enterProductVariants")}
                        {...register("variants")}
                        // value={inventory}
                        // onChange={(e) => setInventory(e.target.value)}
                      />
                      {errors?.variants && (
                        <span style={styles.error}>
                          {errors?.variants?.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} controlId="minQuantity">
                      <Form.Label>{t("product.minimumQuantity")}*</Form.Label>
                      <Form.Control
                        type="text"
                        defaultValue="1"
                        placeholder={t("product.enterMinimumQuantity")}
                        {...register("minQuantity")}

                        // value={minQuantity}
                        // onChange={(e) => setMinQuantity(e.target.value)}
                        // required
                      />
                      {errors?.minQuantity && (
                        <span style={styles.error}>
                          {errors?.minQuantity?.message}
                        </span>
                      )}
                      {storeError?.weight && (
                        <span style={styles.error}>
                          {storeError?.weight}
                        </span>
                      )}
                    </Form.Group>

                    {/* 
                    <Form.Group as={Col} controlId="unitOfMeasure">
                      <Form.Label>{t("product.unitOfMeasure")}</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={t("product.unitOfMeasure")}
                        {...register("unitOfMeasure")}
                        // value={unitOfMeasure}
                        // onChange={(e) => setUnitOfMeasure(e.target.value)}
                      />
                      {errors.unitOfMeasure && (
                        <span style={styles.error}>
                          {errors.unitOfMeasure.message}
                        </span>
                      )}
                    </Form.Group> */}

                    <Form.Group as={Col} controlId="maxQuantity">
                      <Form.Label>{t("product.maximumQuantity")}*</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder={t("product.enterMaximumQuantity")}
                        {...register("maxQuantity")}

                        // value={variants}
                        // onChange={(e) => setVariants(e.target.value)}
                      />
                      {/* {errors?.maxQuantity && (
                        <span style={styles.error}>
                          {errors?.maxQuantity?.message}
                        </span>
                      )} */}
                      {storeError?.maximum_qty && (
                        <span style={styles.error}>
                          {storeError?.maximum_qty}
                        </span>
                      )}
                    </Form.Group>
                  </Row>

                  <Row>
                    <Form.Group as={Col} controlId="Sku">
                      <Form.Label>{t("product.sku")}*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={t("product.enterSku")}
                        {...register("sku")}
                        // value={variants}
                        // onChange={(e) => setVariants(e.target.value)}
                      />
                      {errors?.sku && (
                        <span style={styles.error}>{errors?.sku?.message}</span>
                      )}
                      {/* {storeError?.maximum_qty && (
                        <span style={styles.error}>
                          {storeError?.maximum_qty}
                        </span>
                      )} */}
                    </Form.Group>
                  </Row>
                  <Row>
                    <Form.Group as={Col} controlId="inventory">
                      <Form.Label>{t("product.inventory")}*</Form.Label>
                      <Form.Control
                        type="number"
                        placeholder={t("product.inventory")}
                        {...register("inventory")}
                        // value={inventory}
                        // onChange={(e) => setInventory(e.target.value)}
                      />
                      {errors?.inventory && (
                        <span style={styles.error}>
                          {errors?.inventory?.message}
                        </span>
                      )}
                      {storeError?.available && (
                        <span style={styles.error}>
                          {storeError?.available}
                        </span>
                      )}
                    </Form.Group>
                    <Form.Group as={Col} controlId="threshold_limit">
                      <Form.Label>{"Threshold limit"}*</Form.Label>
                      <Form.Control
                        type="text"
                        placeholder={"Enter threshold limit"}
                        {...register("threshold_limit")}

                        // value={priceInNepali}
                        // onChange={(e) => setPriceInNepali(e.target.value)}
                        // required
                      />
                      {errors?.priceInNepali && (
                        <span style={styles.error}>
                          {errors?.threshold_limit?.message}
                        </span>
                      )}
                    </Form.Group>
                  </Row>
                  <Form.Group as={Col} controlId="priceInNepali">
                    <Form.Label>{t("product.priceInNepali")}*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={t("product.priceInNepali")}
                      {...register("priceInNepali")}

                      // value={priceInNepali}
                      // onChange={(e) => setPriceInNepali(e.target.value)}
                      // required
                    />
                    {errors?.priceInNepali && (
                      <span style={styles.error}>
                        {errors?.priceInNepali?.message}
                      </span>
                    )}
                  </Form.Group>

                  <Form.Group controlId="productImage" ref={productImageRef}>
                    <Form.Label>{t("product.productImage")}*</Form.Label>
                    <Controller
                      name="productImage"
                      control={control}
                      render={({ field }) => (
                        <Form.Control
                          type="file"
                          accept="image/*"
                          ref={field.ref}
                          onBlur={field.onBlur}
                          onChange={(e) => handleFileChange(e, field.onChange)}
                        />
                      )}
                    />
                    {errors?.productImage && (
                      <span style={styles.error}>
                        {errors?.productImage?.message}
                      </span>
                    )}
                    {storeError?.product_image && (
                      <span style={styles.error}>
                        {storeError?.product_image}
                      </span>
                    )}
                  </Form.Group>
                  <Form.Group controlId="AdditionalImage1">
                    <Form.Label>{t("product.additionalImage1")}</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleAdditionalFile1(e)}
                    />
                    {/* {storeError.Additional_image && (
                      <span style={styles.error}>
                        {storeError.Additional_image}
                      </span>
                    )} */}
                  </Form.Group>
                  <Form.Group controlId="AdditionalImage2">
                    <Form.Label>{t("product.additionalImage2")}</Form.Label>
                    <Form.Control
                      type="file"
                      accept="image/*"
                      onChange={(e) => handleAdditionalFile2(e)}
                    />
                    {/* {storeError.Additional_image && (
                      <span style={styles.error}>
                        {storeError.Additional_image}
                      </span>
                    )} */}
                  </Form.Group>

                  <p style={styles.heading}>{t("product.otherLanguage")}</p>
                  <Form.Group as={Col} controlId="productNameInNepali">
                    <Form.Label>{t("product.productNameInNepali")}*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={t("product.productNameInNepali")}
                      {...register("productNameInNepali")}

                      // value={productNameInNepali}
                      // onChange={(e) => setProductNameInNepali(e.target.value)}
                      // required
                    />
                    {errors?.productNameInNepali && (
                      <span style={styles.error}>
                        {errors?.productNameInNepali?.message}
                      </span>
                    )}
                  </Form.Group>
                  <Form.Group as={Col} controlId="descriptionInNepali">
                    <Form.Label>{t("product.descriptionInNepali")}*</Form.Label>
                    <Form.Control
                      type="text"
                      placeholder={t("product.descriptionInNepali")}
                      {...register("descriptionInNepali")}

                      // value={descriptionInNepali}
                      // onChange={(e) => setDescriptionInNepali(e.target.value)}
                      // required
                    />
                    {errors?.descriptionInNepali && (
                      <span style={styles.error}>
                        {errors?.descriptionInNepali?.message}
                      </span>
                    )}
                  </Form.Group>

                  <div className="align-items-center justify-content-center d-flex">
                    <button
                      type="submit"
                      className="btnBlue submit"
                      disabled={isLoading}
                      onClick={handleSubmit(handleSubmits)}
                    >
                      {isLoading ? <BtnLoader /> : t("commonFormLabels.submit")}
                    </button>
                  </div>
                </>
              )}
              {productType === "bulk" && (
                <>
                  <ProductBulkUpload styles={styles} t={t} />
                </>
              )}

              {productType === "system" && (
                // <Form.Group controlId="systemProductID">
                //   <Form.Label>System Product ID</Form.Label>
                //   <Form.Control
                //     type="text"
                //     placeholder="Enter system product ID"
                //     value={systemProductID}
                //     onChange={(e) => setSystemProductID(e.target.value)}
                //     required
                //   />
                // </Form.Group>
                <AddProductFromSystem />
              )}
            </Form>
          </Container>
        </div>
      </Section>
    </div>
  );
};

export default AddProduct;
